import { useCallback } from 'preact/hooks';

const twitchLambdaURI = `${import.meta.env.VITE_TWITCH_URI}`;

export default function useTwitchRequest({
  twitchAccessToken,
  tokenValidated = false,
}) {
  return useCallback(
    (url, body, method = 'POST') => {
      if (
        !twitchAccessToken ||
        twitchAccessToken.length === 0 ||
        !tokenValidated
      )
        return Promise.resolve(null);

      const headers = new Headers();
      headers.set('Content-Type', 'application/json');
      headers.set('Authorization', twitchAccessToken);

      let success = false;
      return fetch(`${twitchLambdaURI}${url}`, {
        method,
        body: body ? JSON.stringify(body) : undefined,
        headers,
      })
        .then((response) => {
          success = response.ok;
          return response.json();
        })
        .catch(() => null)
        .then((result) => {
          return { data: result, success };
        });
    },
    [twitchAccessToken, tokenValidated]
  );
}
